import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useStaffSession } from './hooks/useStaffSession.js'

/**
 * Auth gate for staff pages. Mirrors OwnerRoute: 401 → /staff/login,
 * loading → placeholder, error → surfaced with retry (no silent redirect).
 */
export function StaffRoute({ children }: { children: ReactNode }) {
  const { data, isLoading, isError, error, refetch } = useStaffSession()

  if (isLoading) {
    return (
      <div className="owner-root">
        <div className="owner-session-loading">
          <span
            className="stamp-spinner-square stamp-spinner-square--lg"
            aria-hidden="true"
          />
          <p>Checking your session…</p>
        </div>
      </div>
    )
  }

  if (isError) {
    return (
      <div className="owner-root">
        <div className="owner-error-state">
          <p>We couldn't verify your session.</p>
          <p className="owner-hint">
            {error instanceof Error ? error.message : 'Unexpected error'}
          </p>
          <button
            type="button"
            className="owner-btn"
            onClick={() => void refetch()}
          >
            Retry
          </button>
        </div>
      </div>
    )
  }

  if (!data) {
    return <Navigate to="/staff/login" replace />
  }

  return <>{children}</>
}
